import { render, staticRenderFns } from "./change-recommended-modal.vue?vue&type=template&id=0e8f430f&scoped=true"
import script from "./change-recommended-modal.vue?vue&type=script&lang=js"
export * from "./change-recommended-modal.vue?vue&type=script&lang=js"
import style0 from "./change-recommended-modal.vue?vue&type=style&index=0&id=0e8f430f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e8f430f",
  null
  
)

export default component.exports